import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SaveFileDialogService{
  saveFile(blob: Blob, fileName: string, onComplete?: () => void) {
    const reader = new FileReader();
      reader.onload = () => {
        const bom = new Uint8Array([0xEF, 0xBB, 0xBF]); // UTF-8 BOM
        const utf8Csv = new Blob([bom, reader.result as string], { type: 'text/csv;charset=utf-8;' });


          const url = window.URL.createObjectURL(utf8Csv);
          const a = window.document.createElement('a');
          a.href = url;
          a.download = fileName;
          window.document.body.appendChild(a);
          a.click();
          window.document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
      };
      reader.readAsText(blob, 'utf-8'); // Explicitly read as UTF-8
      setTimeout(() => {
        if (onComplete) {
            onComplete(); // Execute the callback after the dialog is expected to close
        }
        }, 500); // Small delay to ensure execution after file dialog open
  }
}
